import React from 'react';
import './MonitoredIndividualThreadListItem.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';
import MonitoredIndividualImage from '../MonitoredIndividualImage/MonitoredIndividualImage';

export default function MonitoredIndividualThreadListItem({ monitoredIndividualThreadCollection, selected, onClick }) {
  const { monitoredIndividual } = monitoredIndividualThreadCollection;

  if (logComponent('MonitoredIndividualThreadListItem')) { console.debug('MonitoredIndividualThreadListItem rendered'); }

  const monitoredIndividualHasUnreadMessage = () => {
    if (logComponent('MonitoredIndividualThreadListItem')) { console.debug('MonitoredIndividualThreadListItem monitoredIndividualHasUnreadMessage'); }
    const { threads } = monitoredIndividualThreadCollection;

    return threads.some(thread => !thread.isReadByFacility);
  }

  const handleClick = () => {
    if (logComponent('MonitoredIndividualThreadListItem')) { console.debug('MonitoredIndividualThreadListItem handleClick'); }
    onClick(monitoredIndividualThreadCollection);
  }

  return (
    <li  className={'Monitored-Individual-Thread-List-Item' + (selected ? ' Monitored-Individual-Thread-List-Item--selected' : '')}>
      <button onClick={handleClick}>
        <div className="Monitored-Individual-Thread-List-Item__image">
          <MonitoredIndividualImage monitoredIndividual={monitoredIndividual} />
        </div>
        <p className="Monitored-Individual-Thread-List-Item__name">{`${monitoredIndividual.legalFirstName} ${monitoredIndividual.lastName}`}</p>
        {
          monitoredIndividualHasUnreadMessage() &&
          <FontAwesomeIcon icon="circle" className="Monitored-Individual-Thread-List-Item__unread-icon" />
        }
      </button>
    </li>
  );
}
